<template >
  <div >
    <!--    <h1>ro===</h1>-->
    <s-table
        ref="drafts"
        rowKeyField="id"
        :heightWish="false"
        :pagging="1000"
        v-model="relDrafts"
        :editDisabled="!allowEdit"
        :allwaysEdit="allowEdit!==false"
        :colDefinitions="colDefinitions"
        modx-processor="transdrafts/vuegetlist"
        :r-query="qrelDrafts"
        :lazyLoader="false"
        :addEmptyLine="allowEdit!==false"
        :sortingProp="false"
        @cell-input="handleRelDraft"
        @cell-clicked="handleTrans"
        :newRowData="newRow" ></s-table >
  </div >
</template >
<script >
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/acc_commons";
import {mapActions, mapGetters} from "vuex";
import {removeObject} from "../../../api/resource";

export default {
  mixins: [commons],
  name: "EmbDraftsTable",
  props: {
    invoiceMode: {type: Boolean, default: false},
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    value: {
      type: Object,
      default: () => {
      }
    },
    allowEdit: {type: Boolean, default: true},
    type: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      relDrafts: [],
      cachedTrans: null,
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY"
    };
  },
  // watch: {
  //   "$route.query.selectedTrans": {
  //     handler(val, oldval) {
  //       if (val == oldval) return;
  //       // this.disabled = true;
  //       this.parentDraftId = val;
  //       this.dialogVisible = !!val;
  //     },
  //     immediate: true
  //   },
  //   "TransDraft.id": {
  //     handler(val) {
  //       // if (!this.dialogVisible) return;
  //       if (!val) return;
  //       var dr = {};
  //       dr.exectime = "now";
  //       dr.time = "now";
  //       dr.businessId = this.value.businessId;
  //       dr.title = this.value.title;
  //       dr.isincome = this.value.isincome;
  //       dr.parentid = this.$route.query.selectedTrans;
  //       dr.in = this.$route.params.direction;
  //       dr.place = this.value.place;
  //       dr.tags = this.value.tags;
  //       this.newRow = dr;
  //       _log_("new val", this.newRow);
  //       this.$nextTick(() => {
  //         // this.$refs.drafts.appendTrackedData([
  //         //   { title: this.value.title }
  //         // ]);
  //         this.disabled = false;
  //       });
  //     },
  //     immediate: true
  //   }
  // },
  computed: {
    payMessage() {
      if (!this.value) return;
      var msg =
          "Δεν υπαρχει υπόλοιπο για αυτην την χρεωση (" +
          this.$theMoney(this.value.cost) +
          ")";

      const bl = parseFloat(this.value.cost) - parseFloat(this.value.balanse);
      if (bl > 0)
        msg =
            "Το υπολοιπο είναι <strong>" +
            this.$theMoney(bl) +
            "</strong> απο " +
            this.$theMoney(this.value.cost);

      return msg;
    },

    qrelDrafts() {
      _log_(">>>>qrelDrafts>", this.value);
      if (this.value.timologioId)
        return {timologioid: this.value.timologioId, focus: "depts", sort: 'time'};
      if (this.value.timologioid)
        return {timologioid: this.value.timologioid, focus: "depts", sort: 'time'};
      return this.value.id
          ? {selectedTrans: this.value.id, focus: this.type + "s", sort: 'time'}
          : null;
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);
      if (this.invoiceMode !== false) return [
        // {prop: "id", width: "", editable: false, label: "id"},
        {
          prop: "title",
          minWidth: "250px",
          editable: true,
          label: "Description"
        },

        {
          prop: "tags",
          minWidth: "120px",
          editable: true,
          label: "Type",
          // editorcomponent: {
          //   is: "s-select",
          //   allowAdd: false,
          //   multiple: true,
          //   filterable: true,
          //   placeholder: "Για τί πρόκειται...",
          //
          //   endPoint: vm.qTags,
          //   valueProp: "tags",
          //   labelProp: "tags"
          // }
        },
        {
          prop: "cost",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "Net Cost",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponent: {
            is: "sf-button",
            material: "delete",
            type: 'danger',

          },
          formatter(val, colDefs, row) {
            return "-";
          }
        }
        // {
        //   prop: "transactionId",
        //   width: "60px",
        //   label: "X",
        //   onlyEditMode: true,
        //   editable: true,
        //   sortable: false,
        //   editorcomponent: {
        //     is: "el-button",
        //     icon: "el-icon-top-right",
        //     type: "success",
        //     circle: true
        //   },
        //   formatter(val, colDefs, row) {
        //     return "-";
        //   }
        // }
      ]
      let cols = [
        // { prop: "transactionId", width: "", editable: false, label: "id" },
        {
          prop: "title",
          minWidth: "250px",
          editable: true,
          label: "Περιγραφη"
        },

        {
          prop: "tags",
          minWidth: "170px",
          editable: true,
          label: "Κατηγορίες",
          editorcomponent: {
            is: "s-select",
            allowAdd: false,
            multiple: true,
            filterable: true,
            placeholder: "Για τί πρόκειται...",

            endPoint: vm.qTags,
            valueProp: "tags",
            labelProp: "tags"
          }
        },
        {
          prop: "place",
          minWidth: "120px",
          editable: true,
          label: "Εδρα",
          editorcomponent: {
            is: "s-select",
            allowAdd: false,
            multiple: false,
            filterable: true,
            placeholder: "Για τί πρόκειται...",

            endPoint: vm.qPlaces,
            valueProp: "place",
            labelProp: "place"
          }
        }
      ];
      if (this.type == "dept") {
        cols.push({
          prop: "pretaxcost",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "Ποσο",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        });
        cols.push({
          prop: "vat",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "ΦΠΑ",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        });
        cols.push({
          prop: "cost",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "Με ΦΠΑ",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        });
      }
      else {
        cols.push({
          prop: "paymenttype",
          width: "120px",
          editable: true,
          label: "Πηρωμη σε",

          editorcomponent: {
            is: "s-select",
            allowAdd: false,
            filterable: true,
            multiple: false,
            options: [
              {value: "cash", label: "Μετρητα"},
              {value: "bank", label: "Τραπεζα"},
              {value: "bank_deposit", label: "Τραπεζ.Κατάθ."},
              {value: "invoiced", label: "Τιμολογιο"},
              {value: "other", label: "Αλλο"},
              {value: "stock", label: "Πιστοτικο"},
              {value: "visa", label: "POS"}
            ]
          }
        });
        cols.push({
          prop: "cost",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "Πληρωμη",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        });
      }
      cols.push({
        prop: "delete",
        width: "60px",
        label: "X",
        onlyEditMode: true,
        editable: true,
        sortable: false,
        editorcomponent: {
          is: "sf-button",
          material: "delete",
          confirm: "Are you sure?",
          circle: true
        },
        formatter(val, colDefs, row) {
          return "-";
        }
      });
      cols.push({
        prop: "transactionId",
        width: "60px",
        label: "X",
        onlyEditMode: true,
        editable: true,
        sortable: false,
        editorcomponent: {
          is: "el-button",
          icon: "el-icon-top-right",
          type: "success",
          circle: true
        },
        formatter(val, colDefs, row) {
          return "-";
        }
      });

      return cols;
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration"
    })
  },

  mounted() {
    this.loaded = true;
    // this.$nextTick(() => {
    //   this.$refs.drafts.goAddNewLine(true);
    // });
    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  watch: {
    relDrafts: {
      handler: function (newValue) {
        if (!newValue && !this.cachedTrans) return
        const qStamp = JSON.stringify(newValue);
        _log_("UPPPP..", newValue);
        if (qStamp != this.cachedTrans) {
          this.cachedTrans = qStamp;
          this.$emit('transctionsChanged', newValue)
        }
      },
      deep: true
    },
  },
  methods: {
    init() {
    },
    async handleTrans(e) {
      const vm = this
      _log_("UPPPP.this.value.", e);
      if (this.allowEdit !== false) {

        if (e.column.property == "transactionId") {
          if (!e.row.id) return;
          this.$router.push({
            name: "transaction",
            params: {transid: e.row.id}
          });
        }
        if (e.column.property == "delete") {
          if (!e.row.id) return;
          this.$confirm('This will delete the line from the invoice. Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
              .then(async () => {
                await api.removeObject('transdrafts', {id: e.row.id})
                vm.$refs.drafts.removeRow(e.row)
              })
              .catch(() => {
                // this.$message({
                //   type: 'info',
                //   message: 'Delete canceled'
                // });
              });

        }
      }
    },
    async handleRelDraft(data) {
      //

      // return
      if (!this.value) return;

      let dr = data.row;

      dr.exectime = "now";
      dr.time = "now";
      dr.businessId = this.value.businessId;
      dr.isincome = this.value.isincome;
      if (this.value.timologioId) {
        dr.parentid = null;
        dr.isincome = 1;
        dr.timologioid = this.value.timologioId;
        dr.vat = this.value.vat
        if (!dr.type) dr.type = 'dept'
      }
      else
        dr.parentid = this.value.parentid ? this.value.parentid : this.value.id;
      // if (!dr.vat)

      dr.in = this.$route.params.direction;
      dr.place = this.value.place;
      // dr.isicome = this.$route.params.direction == "in";
      // if (dr.transType) dr.type =dr.transType;
      if (!dr.type) dr.type = this.type;
      //
      if (data.prop == "pretaxcost" && dr.vat)
        dr.cost = dr.pretaxcost * ((parseFloat(dr.vat) + 100) / 100);
      if (data.prop == "cost" && dr.vat)
        dr.pretaxcost = dr.cost / ((parseFloat(dr.vat) + 100) / 100);
      if (dr) {
        if (dr.type == 'dept')
          dr.deptamound = dr.cost
        else
          dr.payedamound = dr.cost
        const isNew = !dr.id;
        const drUpdate = await api.updateProcessor("transdrafts/update", dr);
        if (this.$refs.drafts) {
          // if (isNew) {
          _log_("UPPPP.updateRow.", dr, data);
          this.$refs.drafts.updateRow({idx: dr.idx}, {id: drUpdate.id});
        }
        // this.$nextTick(() => {
        //   this.$refs.drafts.goAddNewLine();
        // });
        // }
        // if (!isNew) this.$refs.drafts.updateRow(d);
        // else this.$refs.drafts.updateRow({ id: null }, d);
      }

      // this.$router.push({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.value = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    }
  }
};
</script >
